if (!customElements.get('billion-preview-directory')) {
  customElements.define('billion-preview-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.books = Array.from(this.querySelectorAll('[data-preview-book]'));
      this.grid = this.querySelector('[data-preview-grid]');
      this.search = this.querySelector('[data-preview-search]');
      this.sort = this.querySelector('[data-preview-sort]');
      this.count = this.querySelector('[data-preview-count]');
      this.empty = this.querySelector('[data-preview-empty]');
      this.normalize = (text) => text.normalize('NFKD').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      this.querySelector('[data-preview-tools]').hidden = false;
      this.search.addEventListener('input', () => this.update());
      this.sort.addEventListener('change', () => this.update());
      this.querySelector('[data-preview-reset]').addEventListener('click', () => {
        this.search.value = '';
        this.update();
        this.search.focus();
      });
      this.update();
    }

    update() {
      const words = this.normalize(this.search.value).split(' ').filter(Boolean);
      const sorted = [...this.books];
      if (this.sort.value !== 'shelf') {
        const direction = this.sort.value === 'az' ? 1 : -1;
        sorted.sort((a, b) => direction * a.dataset.title.localeCompare(b.dataset.title, 'en', { sensitivity: 'base' }));
      }
      let count = 0;
      const fragment = document.createDocumentFragment();
      sorted.forEach((book) => {
        book.hidden = !words.every((word) => this.normalize(book.dataset.title).includes(word));
        if (!book.hidden) count++;
        fragment.append(book);
      });
      this.grid.append(fragment);
      this.count.textContent = `${count} ${count === 1 ? 'free preview' : 'free previews'}${words.length ? ` of ${this.books.length}` : ''}`;
      this.empty.hidden = count > 0;
    }
  });
}
